import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import classes from '../agenda.module.scss';
import { ReactComponent as TimeSvg } from '../../../../assets/icons/time.svg';
import { ReactComponent as AddressSvg } from '../../../../assets/icons/home.svg';
import { ReactComponent as AddPostIcon } from '../../../../assets/icons/chatPlus.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit_btn_icon.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/close.svg';
import accountHelpers from '../../../../utils/accountHelpers';

const VisitView = ({
  currentDate, visitedUsers, showPrevBtn, showNextBtn, changeVisitDate, openingNoteAddModal,
  setAgendaInfo, setDeletingId,
}) => {
  const currentUserId = accountHelpers.getUser().id;
  const isAdmin = accountHelpers.isInOneOfRoles(['Admin', 'Pharmacy']);

  const groupByRep = _.groupBy(visitedUsers, 'Rep');

  return (
    <div className={classes.visit_view_wrapper}>
      <div className={classes.date_wrapper}>
        {showPrevBtn && (
          <div
            className={classes.prev_arrow}
            onClick={() => changeVisitDate(true)}
            role="button"
            tabIndex="0"
          >
            <div />
          </div>
        )}

        <div className={classes.date}>
          {moment(currentDate).format('dddd, MMMM DD, YYYY')}
        </div>

        {showNextBtn && (
          <div
            className={classes.next_arrow}
            onClick={() => changeVisitDate()}
            role="button"
            tabIndex="0"
          >
            <div />
          </div>
        )}
      </div>

      <div className={classes.view_content}>
        {_.map(groupByRep, (data, key) => (
          <div key={key}>
            <h4>
              {key}
              {' '}
              <span>
                {data.length}
                {' '}
                appointments
              </span>
            </h4>

            <ul className={classes.info_wrapper}>
              {data.map((d) => {
                const address = _.compact([d.physician.addressStreet,
                  d.physician.addressCity, d.physician.addressState, d.physician.addressZipCode]);

                return (
                  <li key={d.id}>
                    {(isAdmin || +d.RepId === +currentUserId) && (
                    <div className={classes.settings}>
                      <EditIcon
                        className={classes.edit}
                        onClick={() => setAgendaInfo(d)}
                      />

                      <DeleteIcon
                        className={classes.delete}
                        onClick={() => setDeletingId(d.id)}
                      />
                    </div>
                    )}

                    <TimeSvg className={classes.time_svg} />

                    {moment.utc(d.dateTime).local().format('hh:mm a')}
                    {' '}

                    <NavLink to={`/physicians/${d.PhysicianId}`}>
                      <span className={classes.physician_name}>
                        {d.Physician || d.PhysicianName}
                      </span>
                    </NavLink>

                    {' '}
                    {d.group && (
                      <span className={classes.group_name}>
                        (
                        {d.group}
                        )
                      </span>
                    )}

                    {!!address.length && (
                      <div className={classes.address}>
                        <AddressSvg className={classes.address_svg} />

                        {address.join(', ')}
                      </div>
                    )}

                    <div className={classes.notes}>
                      {d.visitNotes.map((v) => (
                        <div key={v.id}>
                          {v.note}
                        </div>
                      ))}

                      <button
                        className={classes.add_post_wrapper}
                        onClick={() => openingNoteAddModal({ visitId: d.id, physicianId: d.PhysicianId })}
                      >
                        <AddPostIcon />

                        Add Note
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

VisitView.propTypes = {
  visitedUsers: PropTypes.array.isRequired,
  currentDate: PropTypes.string.isRequired,
  showPrevBtn: PropTypes.bool.isRequired,
  showNextBtn: PropTypes.bool.isRequired,
  changeVisitDate: PropTypes.func.isRequired,
  openingNoteAddModal: PropTypes.func.isRequired,
  setAgendaInfo: PropTypes.func.isRequired,
  setDeletingId: PropTypes.func.isRequired,
};

export default VisitView;
